
<div class="parent-container">
  @if (showEmailForm) {
    <div class="container_login">
      <app-email-verification
        (verified)="handleOtpVerified()"
      ></app-email-verification>
    </div>
  }

  @if (!showEmailForm) {
    <div>
      <app-customer-form></app-customer-form>
    </div>
  }
</div>
